@for (phaseNode of _projectsFeature.generateTreeDataSourceForPhases(projectNo); track phaseNode.phaseNo) {
  <div class="grid grid-cols-9 rounded px-2 cursor-pointer hover:bg-gray-100" (click)="handleSelectingPhase(phaseNode.projectNo, phaseNode.phaseNo)">
    <p class="text-sm font-bold text-black col-start-1 col-end-6" [innerHTML]="phaseNode.phaseNo + ' - ' + phaseNode.phaseName + ' ' + phaseNode.phaseDescription | highlight: _projectsFeature.searchText()"></p>
    @if (phaseNode.workItemId) {
      <p class="text-sm font-bold text-blue-600 text-right col-start-6 col-end-7" [innerHTML]="'#' + phaseNode.workItemId | highlight: _projectsFeature.searchText()"></p>
    }
    <p class="text-sm font-bold text-black text-right col-start-7 col-end-8">Est. Hours</p>
    <p class="text-sm font-bold text-black text-right col-start-8 col-end-9">Actual Hours</p>
  </div>

  <mat-list>
    @for (taskNode of phaseNode.children; track taskNode.taskNo) {
      <mat-list-item class="p-0">
        <div class="grid grid-cols-9 rounded px-2 cursor-pointer hover:bg-gray-100" (click)="handleSelectingTask(taskNode)">
          <p class="text-sm col-start-1 col-end-6 pl-[20px]">
            <span [innerHTML]="taskNode.taskNo + ' - ' + taskNode.taskName | highlight: _projectsFeature.searchText()"></span>
          </p>
          @if (taskNode.workItemId) {
            <span class="text-sm text-blue-600 text-right col-start-6 col-end-7" [innerHTML]="'#' + taskNode.workItemId | highlight: _projectsFeature.searchText()"></span>
          }
          <span class="text-sm text-right col-start-7 col-end-8">{{ taskNode.taskEstimatedHours | number: "1.0-2" }}</span>
          <span class="text-sm text-right col-start-8 col-end-9">{{ taskNode.actualHours | number: "1.0-2" }}</span>
        </div>
      </mat-list-item>
    } @empty {
      <div class="w-full flex justify-center items-center pt-[20px]">
        <p class="text-sm">No tasks added yet.</p>
      </div>
    }
  </mat-list>
} @empty {
  <div class="w-full flex justify-center items-center pt-[20px]">
    <p class="text-sm">No phases added yet.</p>
  </div>
}
